import React, { useMemo } from 'react';
import { Col, Row, Space } from 'antd';
import { useUnit } from 'effector-react/effector-react.mjs';
import { Column, Pie } from '@ant-design/charts';
import Divider from 'antd/es/divider';
import style from './MGPRegistry.module.css';
import {
  $nmpData,
  $nmpDataDup,
  applyNMPFiltersDupEv,
  applyNMPFiltersEv,
  NMPGate,
  resetNMPFiltersDupEv,
  resetNMPFiltersEv,
} from '../../models/mgpModel/index.js';
import NMPFilters from './components/NMPFilters.jsx';
import { formatNumber } from '../../utils/number-manipulation.js';
import NmpContent from './components/NMPContent.jsx';

function NmpRegistry() {
  const nmpData = useUnit($nmpData);
  const nmpDataDup = useUnit($nmpDataDup);

  const apply = useUnit(applyNMPFiltersEv);
  const reset = useUnit(resetNMPFiltersEv);
  const applyDup = useUnit(applyNMPFiltersDupEv);
  const resetDup = useUnit(resetNMPFiltersDupEv);

  return (
    <>
      <NMPGate />
      <NmpContent nmpData={nmpData} apply={apply} reset={reset} />
      <Divider />
      <NmpContent nmpData={nmpDataDup} apply={applyDup} reset={resetDup} />
    </>
  );
}

export default NmpRegistry;
